import React from "react";
import { connect } from "react-redux";
import { Checkbox, Row } from 'antd';

//action imports
import { userAccessChanged } from "../../../actions/AuthenticationActions";

class UserAccess extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value
        };
    }

    onChange(checkedValues) {
       this.props.userAccessChanged(checkedValues);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.value !== this.props.value) {
            this.setState({ value: nextProps.value })
        }
    }

    render() {
        return(
            <div className={"userAccess"}>
                <h3>Account Page Access</h3>
                <Checkbox.Group className={"userAccessCheckbox"} onChange={(values) => this.onChange(values)} value={this.state.value}>
                    <Row>
                        <Checkbox value="announcements">Announcements</Checkbox>
                    </Row>
                    <Row>
                        <Checkbox value="activities">Activities</Checkbox>
                    </Row>
                    <Row>
                        <Checkbox value="classCommunities">Class/Communities</Checkbox>
                    </Row>
                    <Row>
                        <Checkbox value="profiles">Profiles</Checkbox>
                    </Row>
                    <Row>
                        <Checkbox value="settings">Settings</Checkbox>
                    </Row>
                </Checkbox.Group>
            </div>
        );
    }
}

export default connect(null, { userAccessChanged })(UserAccess);